module.exports = __webpack_public_path__ + "static/img/baoman.d3e4a9f1.png";